export const parseParagraphs = (stringToParse) => {
    if (!stringToParse) {
        return;
    }

    const paragraphArray = stringToParse.split("\n");

    return paragraphArray;
};
